/**
 * Created by changlei on 2018/1/19.
 */

/**
 * clickoutsideContext 指令上下文
 * @type {string}
 */
const clickoutsideContext = '@@clickoutsideContext';
/**
 * 自定义指令
 */
export default {

  /*
   @param el 指令所绑定的元素
   @param binding {Object}
   @param vnode vue编译生成的虚拟节点
   */
  bind (el, binding, vnode) {
    const documentHandler = function(e) {
      //console.log(el)
      //console.log(e.target);
      //console.log(vnode);
      //console.log(binding);

      //过滤掉自身元素  不触发外部指令
      if(!vnode.context || el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        vnode.context[el[clickoutsideContext].methodName](e)
      } else {
        el[clickoutsideContext].bindingFn(e);
      }
    }
    //为当前绑定元素，创建一个属性，存储指令信息
    el[clickoutsideContext] = {
      documentHandler,
      methodName: binding.expression,
      bindingFn: binding.value
    }
    setTimeout(() => {
      //为整个document 添加点击事件
      document.addEventListener('click', documentHandler);
    }, 0)
  },
  update (el, binding) {
    el[clickoutsideContext].methodName = binding.expression;
    el[clickoutsideContext].bindingFn = binding.value;
  },
  unbind(el) {
    //为整个document 移除点击事件
    document.removeEventListener('click', el[clickoutsideContext].documentHandler);
  }
}



// WEBPACK FOOTER //
// ./src/components/controls/clickoutside-es6.js